import { render, staticRenderFns } from "./coin-manage.vue?vue&type=template&id=0157d3f6&scoped=true&"
import script from "./coin-manage.vue?vue&type=script&lang=ts&"
export * from "./coin-manage.vue?vue&type=script&lang=ts&"
import style0 from "./coin-manage.vue?vue&type=style&index=0&id=0157d3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0157d3f6",
  null
  
)

export default component.exports